import styled from "styled-components"

export default styled.section`
  width: 100%;
  padding-top: 50px;
  
  .copy-item__box-button{
    margin-top: 20px;
  }
  
  .copy-item__box-select{
    margin-top: 20px;
    margin-left: 0px;
  }
  
  .copy-item__box-label{
    margin-right: 20px;
    text-transform: none;
  }
`
